import React, { createContext, useCallback, useMemo, useState } from 'react';

export const FormValidationContext = createContext({
  isValid: true,
  setFieldStatuses: () => {},
  removeForm: () => {},
  formStatuses: null
});

const FormValidationProvider = ({ children }) => {
  const [formStatuses, setFormStatuses] = useState(() => ({}));

  const setFieldStatuses = useCallback((formKey, fieldStatuses) => {
    setFormStatuses((formStatuses) => {
      formStatuses = { ...formStatuses };
      if (!formStatuses[formKey]) {
        formStatuses[formKey] = {};
      }
      Object.assign(formStatuses[formKey], fieldStatuses);
      return formStatuses;
    });
  }, []);

  const removeForm = useCallback((formKey) => {
    setFormStatuses((formStatuses) => {
      formStatuses = { ...formStatuses };
      delete formStatuses[formKey];
      return formStatuses;
    });
  }, []);

  const ctx = useMemo(
    () => ({
      formStatuses,
      isValid: errorCount(formStatuses) === 0,
      setFieldStatuses,
      removeForm,
    }),
    [formStatuses]
  );

  return (
    <FormValidationContext.Provider value={ctx}>
      {children}
    </FormValidationContext.Provider>
  );
};

function errorCount(formStatuses) {
  let errors = 0;
  Object.values(formStatuses).forEach((fieldStatuses) => {
    Object.values(fieldStatuses).forEach(
      (fieldStatus) =>
        (errors += fieldStatus.errors ? fieldStatus.errors.length : 0)
    );
  });
  return errors;
}

export default FormValidationProvider;
